import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import NormalTextField from "../../components/common/NormalTextField";
import VideoPicker from "../../components/common/VideoPicker";
import ImagePicker from "../../components/common/ImagePicker";
import NormalBigButton from "../../components/common/NormalBigButton";
import ActionButton from "../../components/common/ActionButton";
import "../../resources/styles/instructions.css";
import { Editor } from "react-draft-wysiwyg";
import { convertFromRaw, EditorState, convertToRaw } from "draft-js";
import Fab from "@material-ui/core/Fab";
import IconClear from "material-ui/svg-icons/content/clear";
import IconVideo from "material-ui/svg-icons/av/videocam";
import IconImage from "material-ui/svg-icons/editor/insert-photo";
import IconAdd from "material-ui/svg-icons/content/add-circle-outline";
import FilePicker from "../../components/common/FilePicker";
import NormalFlatButton from "../../components/common/NormalFlatButton";
import DeleteButton from "../../components/common/DeleteButton";
import TextField from "material-ui/TextField";
import UrlUtils from "../utils/urlUtils";
import RichTextEditor from "react-rte";
import FileCloudDownload from "material-ui/svg-icons/file/cloud-download";
import {
  getTextAlignBlockMetadata,
  getTextAlignClassName,
  getTextAlignStyles,
} from "./library/blockStyleFunctions";

import colors from "../../styles/colors";

const style = {
  container: {
    display: "flex",
    flexFlow: "column",
  },
  label: {
    color: colors.primary,
    fontSize: 14,
  },
  video: {
    height: 100,
  },
  image: {
    height: 100,
  },
  buttons: {
    display: "flex",
    flexFlow: "row",
  },
};

class CustomCategoryEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      category: props.category,
      readOnly: props.readOnly ? props.readOnly : false,
      editorState: props.category.categoryDescWithFormat
        ? RichTextEditor.createValueFromString(
            this.getDescription(
              props.category.categoryDesc,
              props.category.categoryDescWithFormat
            ),
            "html"
          )
        : RichTextEditor.createEmptyValue(),
      attachments: {
        videoAdded: props.category.videoUrl ? true : false,
        imageAdded: props.category.imageUrl ? true : false,
      },
    };

    this.updateCategoryData = this.updateCategoryData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.templateSpecificFields = this.templateSpecificFields.bind(this);
    this.saveInstruction = this.saveInstruction.bind(this);
  }

  saveInstruction() {
    let { category } = this.state;

    if (category.videoUrl) {
      // 1) grab the last segment after the last "/"
      const lastSegment = category.videoUrl.split("/").pop(); // e.g. "c_2117_…44c8d.mp4?AWSAccessKeyId=…"

      // 2) strip off the query string
      const fileName = lastSegment.split("?")[0];
      // → "c_2117_…44c8d.mp4"

      // build your clean URLs
      const newVideoUrl =
        "https://user-image-storage.s3.amazonaws.com/compressed/video/" +
        fileName;
      const imgName = fileName.replace(/\.[^/.]+$/, "");
      // remove extension, e.g. ".mp4"
      const newThumbUrl =
        "https://user-image-storage.s3.amazonaws.com/compressed/thumb/" +
        imgName +
        ".0000000.jpg";

      category = {
        ...category,
        videoUrl: newVideoUrl,
        videoPreviewUrl: newThumbUrl,
      };
    }

    this.props.onSave(category);
  }

  updateCategoryData(name, value) {
    let category = {
      ...this.state.category,
      [name]: value,
    };
    this.setState({
      category,
      attachments: {
        videoAdded: this.state.category.videoUrl ? true : false,
        imageAdded: this.state.category.imageUrl ? true : false,
      },
    });
  }

  handleChange(event) {
    this.updateCategoryData(event.target.name, event.target.value);
  }

  getDescription = (description, descriptionFomated) => {
    if (descriptionFomated) {
      if (descriptionFomated[0] === "{") {
        let temp = JSON.parse(descriptionFomated);
        let description = temp.blocks
          .map((block) => block.text + "\n")
          .join("\n");

        return "<p>" + description + "</p>";
      } else {
        let temp = RichTextEditor.createValueFromString(
          descriptionFomated,
          "html"
        );
        return temp.toString("html", { blockStyleFn: getTextAlignStyles });
      }
    } else {
      let temp = RichTextEditor.createValueFromString(
        "<p>" + description + "</p>",
        "html"
      );
      return temp.toString("html", { blockStyleFn: getTextAlignStyles });
    }
  };

  templateSpecificFields() {
    const showExerciseFields = this.props.templateId === 103;

    return (
      <div>
        {showExerciseFields && (
          <div style={style.container}>
            {!this.state.readOnly && (
              <div style={style.label}>
                <br />
                Exercise
              </div>
            )}
            {(!this.state.readOnly ||
              !_.isEmpty(this.state.category.numRepetitions)) && (
              <NormalTextField
                floatingLabelText="Number of Repetitions"
                name="numRepetitions"
                value={this.state.category.numRepetitions}
                onChange={this.handleChange}
                readOnly={this.state.readOnly}
              />
            )}
            {(!this.state.readOnly ||
              !_.isEmpty(this.state.category.numSets)) && (
              <NormalTextField
                floatingLabelText="Number of Sets"
                name="numSets"
                value={this.state.category.numSets}
                onChange={this.handleChange}
                readOnly={this.state.readOnly}
              />
            )}
            {(!this.state.readOnly ||
              !_.isEmpty(this.state.category.intensity)) && (
              <NormalTextField
                floatingLabelText="Intensity"
                name="intensity"
                value={this.state.category.intensity}
                onChange={this.handleChange}
                readOnly={this.state.readOnly}
              />
            )}
            {(!this.state.readOnly ||
              !_.isEmpty(this.state.category.frequency)) && (
              <NormalTextField
                floatingLabelText="Frequency"
                name="frequency"
                value={this.state.category.frequency}
                onChange={this.handleChange}
                readOnly={this.state.readOnly}
              />
            )}
          </div>
        )}
      </div>
    );
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    // const contentState = editorState.getCurrentContent();
    // let description = convertToRaw(contentState).blocks.map( block => block.text + '\n').join('\n');
    // this.setState({category:{...this.state.category, categoryDesc: description, categoryDescWithFormat: JSON.stringify(convertToRaw(contentState)) }})
    let editor = this.state.editorState.getEditorState();
    let contentState = editor.getCurrentContent();
    this.setState({
      category: {
        ...this.state.category,
        categoryDesc: contentState.getPlainText(),
        categoryDescWithFormat: editorState.toString("html", {
          blockStyleFn: getTextAlignStyles,
        }),
      },
    });
  };

  updateVideo = () => {
    if (this.state.category.videoUrl) {
      delete this.state.category.videoUrl;
      this.setState({
        attachments: { ...this.state.attachments, videoAdded: false },
      });
    } else {
      this.setState({
        attachments: { ...this.state.attachments, videoAdded: true },
        category: { ...this.state.category, videoUrl: "" },
      });

      //document.getElementById("videoUploader").click()
    }
  };

  updateImage = () => {
    if (this.state.category.imageUrl) {
      delete this.state.category.imageUrl;
      this.setState({
        attachments: { ...this.state.attachments, imageAdded: false },
      });
    } else {
      this.setState({
        attachments: { ...this.state.attachments, imageAdded: true },
        category: { ...this.state.category, imageUrl: "" },
      });
      //() => document.getElementById("imageUploader").click();
    }
  };

  /*addDocument = () => {
    let documents = this.state.category.documents;
    if (_.isEmpty(documents)) {
      documents = [];
    }
    let emptyDocument = {
      name: "",
      url: "",
    };
    let newDocuments = _.slice(documents);
    newDocuments.push(emptyDocument);

    this.setState({
      category: { ...this.state.category, documents: newDocuments },
    });
  };*/

  addDocument = (fileName, fileUrl) => {
    let documents = this.state.category.documents;
    if (_.isEmpty(documents)) {
      documents = [];
    }
    const nameArr = fileUrl.split("/");

    let originalName = nameArr[nameArr.length - 1];
    originalName = originalName.substring(originalName.indexOf("_") + 1);
    let emptyDocument = {
      name: originalName,
      url: fileUrl,
    };
    let newDocuments = _.slice(documents);
    newDocuments.push(emptyDocument);

    this.setState({
      category: { ...this.state.category, documents: newDocuments },
    });
  };

  updateDocument = (idx, originalDocument, updatedValue) => {
    let newDocument = _.assign({}, originalDocument, updatedValue);
    let updateDocs = this.state.category.documents;
    updateDocs[idx] = newDocument;
    this.setState({
      category: { ...this.state.category, documents: updateDocs },
    });
  };

  removeDocument = (idx) => {
    let documents = this.state.category.documents;
    let filteredDocs = documents.filter((doc, i) => i !== idx);
    this.setState({
      category: { ...this.state.category, documents: filteredDocs },
    });
  };

  render() {
    const toolbarConfig = {
      display: [
        "INLINE_STYLE_BUTTONS",
        "BLOCK_TYPE_BUTTONS",
        "BLOCK_TYPE_DROPDOWN",
        "LINK_BUTTONS",
      ],
      INLINE_STYLE_BUTTONS: [
        { label: "Bold", style: "BOLD", className: "custom-css-class" },
        { label: "Italic", style: "ITALIC" },
        { label: "Underline", style: "UNDERLINE" },
      ],
      BLOCK_TYPE_DROPDOWN: [
        { label: "Normal", style: "unstyled" },
        { label: "Heading Large", style: "header-one" },
        { label: "Heading Medium", style: "header-two" },
        { label: "Heading Small", style: "header-three" },
      ],
      BLOCK_TYPE_BUTTONS: [
        { label: "UL", style: "unordered-list-item" },
        { label: "OL", style: "ordered-list-item" },
      ],
    };
    return (
      <div>
        <div style={style.container}>
          <div className={"ins-counters"}>
            <div className={"ins-counters-item"}>
              <label style={style.insLabel}>Name:</label>
              <input
                value={this.state.category.categoryName}
                onChange={(event) =>
                  this.setState({
                    category: {
                      ...this.state.category,
                      categoryName: event.target.value,
                    },
                  })
                }
              />
            </div>
            <div className={"ins-counters-item"}>
              <label style={style.insLabel}>Description:</label>
              <RichTextEditor
                value={this.state.editorState}
                onChange={this.onEditorStateChange}
                className="wrapper-class-editer"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                blockStyleFn={getTextAlignClassName}
                toolbarConfig={toolbarConfig}
              />
            </div>
          </div>

          <h3 className="inst-header">Instruction Media</h3>
          {!this.state.category.isLocked && (
            <div className={"newAttachments"}>
              <VideoPicker
                videoType="custom"
                hidden={this.state.attachments.videoAdded}
                videoUrl={this.state.category.videoUrl}
                userId={parseInt(this.props.userId)}
                appId={this.props.appId}
                customAppId={this.props.customAppId}
                previewStyle={style.media}
                clearVideo={() => {
                  this.setState({
                    category: {
                      ...this.state.category,
                      videoUrl: null,
                      videoPreviewUrl: null,
                    },
                  });
                }}
                handleSubmit={(videoUrl) =>
                  this.setState({
                    category: {
                      ...this.state.category,
                      videoUrl: videoUrl,
                    },
                  })
                }
              />
            </div>
          )}
          {!this.state.category.isLocked && (
            <div className={"newAttachments"}>
              <ImagePicker
                key={this.state.category.imageUrl}
                imageUrl={this.state.category.imageUrl}
                userId={parseInt(this.props.userId)}
                previewStyle={style.media}
                hidden={this.state.attachments.imageAdded}
                clearImage={() => {
                  this.setState({
                    category: {
                      ...this.state.category,
                      imageUrl: null,
                    },
                  });
                }}
                handleSubmit={(imageUrl) =>
                  this.setState({
                    category: {
                      ...this.state.category,
                      imageUrl: imageUrl,
                    },
                  })
                }
              />
            </div>
          )}

          {!this.state.category.isLocked && (
            <div className="instruction">
              <label>&nbsp;</label>
              <FilePicker
                fileUrl={document.url}
                userId={this.props.userId}
                appId={this.props.appId}
                handleSubmit={(fileName, fileUrl) => {
                  this.addDocument(fileName, fileUrl);
                }}
              />
            </div>
          )}
          {this.state.category.documents &&
            this.state.category.documents.length > 0 && (
              <h3 className="inst-inner-header">Attached Documents</h3>
            )}

          <div className="instruction">
            {this.state.category.documents &&
              this.state.category.documents.map((document, idx) => {
                const fileArr = document.url.split("/");
                let fileName = fileArr[fileArr.length - 1];
                fileName = fileName.substring(fileName.indexOf("_") + 1);

                return (
                  <div className={"ins-counters"}>
                    <div className={"ins-counters-item"}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          border: "solid 1px black",
                          backgroundColor: "#CECECE",
                          width: 500,
                          marginLeft: 100,
                          padding: 10,
                          borderRadius: 3,
                          alignContent: "center",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ flexDirection: "column", width: 400 }}>
                          <input
                            placeholder="Document Name"
                            value={document.name}
                            onChange={(event) => {
                              let name = event.target.value;
                              this.updateDocument(idx, document, { name });
                            }}
                          />
                          <p style={style.attachedText}>
                            Attached File: {fileName}
                          </p>
                        </div>
                        {!_.isEmpty(document.url) && (
                          <FileCloudDownload
                            onClick={() => window.open(document.url, "_blank")}
                          />
                        )}
                        <DeleteButton
                          onClick={() => this.removeDocument(idx)}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          {this.state.category.isLocked && (
            <div className={"ins-counters"}>
              <div className={"ins-counters-item"}>
                <h5>Media Assets Are Locked For This Instruction</h5>
              </div>
            </div>
          )}

          <h3 className="inst-header" style={{ marginTop: 20 }}>
            Hosted Media
          </h3>
          {!this.state.category.isLocked && (
            <div className={"ins-counters"}>
              <div className={"ins-counters-item"}>
                <label style={style.insLabel}>YouTube Video:</label>
                <input
                  placeholder="YouTube Video URL"
                  value={
                    this.state.category.youtubeVideo &&
                    this.state.category.youtubeVideo.url
                  }
                  onChange={(event) =>
                    this.setState({
                      category: {
                        ...this.state.category,
                        youtubeVideo: {
                          url: event.target.value,
                          id: UrlUtils.getYoutubeVideoId(event.target.value),
                        },
                      },
                    })
                  }
                />
              </div>
              <div className={"ins-counters-item"}>
                <label style={style.insLabel}>Wistia Video:</label>
                <input
                  placeholder="Wistia Video URL"
                  value={
                    this.state.category.wistiaVideo &&
                    this.state.category.wistiaVideo.url
                  }
                  onChange={(event) =>
                    this.setState({
                      category: {
                        ...this.state.category,
                        wistiaVideo: {
                          url: event.target.value,
                          id: UrlUtils.getWistiaVideoId(event.target.value),
                        },
                      },
                    })
                  }
                />
              </div>
            </div>
          )}

          {this.props.templateId === 103 && (
            <div>
              <h3 className="inst-header">Instruction Details</h3>
              <div className={"ins-counters"}>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Repetitions:</label>
                  <input
                    placeholder="Number Of Repetitions"
                    value={this.state.category.numRepetitions}
                    onChange={(event) =>
                      this.setState({
                        category: {
                          ...this.state.category,
                          numRepetitions: event.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Sets:</label>
                  <input
                    placeholder="Number Of Sets"
                    value={this.state.category.numSets}
                    onChange={(event) =>
                      this.setState({
                        category: {
                          ...this.state.category,
                          numSets: event.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Duration:</label>
                  <input
                    placeholder="Duration"
                    value={this.state.category.duration}
                    onChange={(event) =>
                      this.setState({
                        category: {
                          ...this.state.category,
                          duration: event.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Intensity:</label>
                  <input
                    placeholder="Intensity"
                    value={this.state.category.intensity}
                    onChange={(event) =>
                      this.setState({
                        category: {
                          ...this.state.category,
                          intensity: event.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={"ins-counters-item"}>
                  <label style={style.insLabel}>Frequency:</label>
                  <input
                    placeholder="Frequency"
                    value={this.state.category.frequency}
                    onChange={(event) =>
                      this.setState({
                        category: {
                          ...this.state.category,
                          frequency: event.target.value,
                        },
                      })
                    }
                  />
                </div>

                {this.state.category.isLocked && (
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Weight:</label>
                    <input
                      placeholder="Weight"
                      value={this.state.category.weight}
                      onChange={(event) =>
                        this.setState({
                          category: {
                            ...this.state.category,
                            weight: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                )}

                {this.state.category.isLocked && (
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Hold:</label>
                    <input
                      placeholder="Hold"
                      value={this.state.category.hold}
                      onChange={(event) =>
                        this.setState({
                          category: {
                            ...this.state.category,
                            hold: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                )}

                {this.state.category.isLocked && (
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Rest:</label>
                    <input
                      placeholder="Rest"
                      value={this.state.category.rest}
                      onChange={(event) =>
                        this.setState({
                          category: {
                            ...this.state.category,
                            rest: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                )}

                {this.state.category.isLocked && (
                  <div className={"ins-counters-item"}>
                    <label style={style.insLabel}>Tempo:</label>
                    <input
                      placeholder="Tempo"
                      value={this.state.category.tempo}
                      onChange={(event) =>
                        this.setState({
                          category: {
                            ...this.state.category,
                            tempo: event.target.value,
                          },
                        })
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <br />
        {!this.state.readOnly && (
          <div className={"dialog-btns-pationts"}>
            <NormalBigButton
              label="Cancel"
              onClick={() => this.props.onCancel()}
            />
            <ActionButton
              label="Save"
              disabled={
                this.state.category.categoryName == null ||
                this.state.category.categoryName.trim().length == 0
              }
              whiteLabelSettings={this.props.whiteLabelSettings}
              onClick={() => this.saveInstruction()}
            />
          </div>
        )}
      </div>
    );
  }
}

CustomCategoryEditor.propTypes = {
  category: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  appId: PropTypes.string.isRequired,
  templateId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
};

export default CustomCategoryEditor;



// WEBPACK FOOTER //
// ./src/layout/playbook/CustomCategoryEditor.js